import { useState, useEffect, useRef } from "react";
import { Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import _, { isEqual } from "lodash";

import Head from "@/components/Content/Head";
import Fetching from "@/components/Fetching/Fetching";
import CreateOrderSaleHead from "./CreateOrderSaleHead";
import CreateOrderSaleTableDetail from "./CreateOrderSaleTableDetail";
import CreateOrderSaleDocument from "./Document/CreateOrderSaleDocument";

import classes from "./createOrderSale.module.scss";

import { useOrderSaleCreate, useOrderSaleSave } from "@/hooks/purchases/orders_sale";

import { baseFilterOrders } from "../orders_sale_constants";
import { baseOrderSale } from "./createOrderSale.constants";
import CreateOrderSaleButton from "./CreateOrderSaleButton";

import { formatMilesDecimalNew } from "@/services/Utils";
import api from "@/services/api.service";

const CreateOrderSale = () => {
	const { option, code } = useParams();
	const { addToast } = useToasts();

	const { filter } = useSelector((state) => state.auth);

	const { estate_parent_id, estate_id, type_currency, search, parameter } = filter;

	const [data, setData] = useState({ ...baseOrderSale });
	const [alerts, setAlerts] = useState([]);
	const [isFetchingDetail, setIsFetchingDetail] = useState(false);
	const [isFetchingExcel, setIsFetchingExcel] = useState(false);
	const [selectedOC, setSelectedOC] = useState([]);
	const [detailOC, setDetailOC] = useState([]);
	const initializedRef = useRef(false);

	const base = { ...baseFilterOrders, estate_parent_id, estate_id, type_currency, search, parameter };
	const params = { estate_parent_id, estate_id, code };

	const { data: response, isLoading, isFetching } = useOrderSaleCreate(params);
	const { mutate: save, isLoading: loadingSave } = useOrderSaleSave(base, params);

	const validFile = () => {
		if (!data.business_id) {
			addToast("Debe seleccionar una razón social para cargar el excel.", {
				appearance: "error",
			});
			return;
		}
		if (!data.estate_id) {
			addToast("Debe seleccionar una campo para cargar el excel.", {
				appearance: "error",
			});
			return;
		}

		return true;
	};

	const uploadFile = (e) => {
		const formData = new FormData();
		formData.append("file", e.target.files[0]);
		formData.append("estate_id", data.estate_id);

		setIsFetchingExcel(true);
		api.post("/client/orders/upload_excel", formData).then((response) => {
			if (Object.prototype.hasOwnProperty.call(response, "rows")) {
				setIsFetchingExcel(false);
				setData({ ...data, items: response.rows });
				return;
			}

			setIsFetchingExcel(false);
		});
	};

	useEffect(() => {
		if (!response || !response.order_sale) return;

		if (["ver", "editar"].includes(option) && !initializedRef.current) {
			const orderData = response.order_sale;

			setData((prevData) => ({
				...prevData,
				...orderData,
				business_id: orderData.business_id || (response.business?.length === 1 ? response.business[0].value : prevData.business_id),
				estate_parent_id:
					orderData.estate_parent_id || (response.estates_parents?.length === 1 ? response.estates_parents[0].value : prevData.estate_parent_id),
				estate_id: orderData.estate_id || (response.estates?.length === 1 ? response.estates[0].value : prevData.estate_id),
				productCustomer: response.products_generic || prevData.productCustomer,
			}));

			initializedRef.current = true;
		} else if (option === "ingresar" && !initializedRef.current) {
			// Modo crear: solo auto-seleccionar si hay una sola opción
			setData((prevData) => ({
				...prevData,
				business_id: response.business?.length === 1 ? response.business[0].value : prevData.business_id,
				estate_parent_id: response.estates_parents?.length === 1 ? response.estates_parents[0].value : prevData.estate_parent_id,
				estate_id: response.estates?.length === 1 ? response.estates[0].value : prevData.estate_id,
				productCustomer: response.products_generic || [],
			}));

			initializedRef.current = true;
		}
	}, [response, option]);

	const checkDetailOC = async (selected_ocs = null) => {
		const orders_ids = _.map(selected_ocs, "value");
		const dealers_ids = _.map(selected_ocs, "dealer_id");
		const ruts_ids = _.map(selected_ocs, "rut_dealer");

		let newProductsIds = data.items.filter((item) => item.product_id !== null && item.product_id !== "").map((item) => Number(item.product_id));

		let typeAlert = "Debe escribir la cantidad de envases y contenido que correspondan.";

		let newDetailOC = [...detailOC];
		if (newProductsIds.length > 0) {
			newDetailOC = newDetailOC.filter((nd) => newProductsIds.includes(Number(nd.product_id)));
		}

		if (selected_ocs && !isEqual(selected_ocs, selectedOC)) {
			setIsFetchingDetail(true);

			const response = await api.get("/client/orders/detail", {
				orders: orders_ids.toString(),
				order_delivery_id: data.id,
				type: "orders_delivery_detail",
			});

			if (response) {
				newDetailOC = response.items;
			}
		}

		let newItems = [...data.items];
		newItems = newItems.filter((ni) => ni.product_id !== "");

		newDetailOC.forEach((element) => {
			let itemsCorrect = [];

			const existInItems = newItems.find((it) => Number(it.order_detail_id) === Number(element.order_detail_id));
			const existInItemsIncomplete = newItems.filter((it) => {
				return (
					(it.order_detail_id === null || it.order_detail_id === "" || it.order_detail_id === element.order_detail_id) &&
					String(it.product_id) === String(element.product_id)
				);
			});

			if (existInItemsIncomplete.length > 0) {
				const elementContainerContent = parseFloat(element.container_content);
				const elementQuantity = parseFloat(element.quantity);

				let totalContent = elementContainerContent * elementQuantity;
				existInItemsIncomplete.forEach((itemIncomplete) => {
					const index = newItems.findIndex((it) => {
						return (
							(it.hash ? it.hash === itemIncomplete.hash : it.id === itemIncomplete.id) &&
							it.product_id === itemIncomplete.product_id &&
							(it.order_detail_id === "" || it.order_detail_id === null || it.order_detail_id === element.order_detail_id)
						);
					});

					if (index !== -1) {
						totalContent = totalContent - itemIncomplete.container_content * itemIncomplete.quantity;
						newItems[index] = { ...itemIncomplete, order_detail_id: element.order_detail_id };
						itemsCorrect.push(itemIncomplete);
					}
				});

				typeAlert = "Se han asociado productos a las ordenes de compra seleccionadas, debe guardar para completar la información.";
			} else if (!existInItems) {
				let newElement = { ...element, hash: new Date().getTime() };
				newItems.push(newElement);

				itemsCorrect.push(newElement);
			}

			newItems.forEach((item, indexItem) => {
				const existInItemsCorrect = itemsCorrect.find((it) => {
					if (item.hash && it.hash) {
						return it.hash === item.hash;
					} else {
						return it.id === item.id;
					}
				});

				if (!existInItemsCorrect) {
					newItems[indexItem] = { ...item, order_detail_id: "" };
				}
			});
		});

		setDetailOC(newDetailOC);
		setSelectedOC(selected_ocs);

		setData({
			...data,
			orders_code: selected_ocs ? orders_ids : data.orders_code,
			dealer_id: selected_ocs ? dealers_ids[0] : data.dealer_id,
			rut_dealer: selected_ocs ? ruts_ids[0] : data.rut_dealer,
			items: newItems,
			productCustomer: data.productCustomer,
		});

		const searchAlert = alerts.find((a) => a.text === typeAlert && a.completed === false);
		if (!searchAlert) {
			const newAlert = { completed: false, text: typeAlert };
			setAlerts([...alerts, newAlert]);
		}

		setIsFetchingDetail(false);

		return newItems;
	};

	const handleValidPriceItem = (newItems, index, textCurrency) => {
		let price_unit_order = Number(newItems[index].price_order);
		const price_unit = Number(newItems[index].price_unit);
		const container_content = Number(String(newItems[index].container_content).replace(",", "."));

		if (newItems[index].type_currency_id === 1 && textCurrency === "USD") {
			if (newItems[index].exchange_rate && newItems[index].exchange_rate > 0) {
				price_unit_order = price_unit_order / newItems[index].exchange_rate;
			} else {
				price_unit_order = 0;
			}
		}

		if (newItems[index].type_currency_id === 2 && textCurrency === "CLP") {
			if (newItems[index].exchange_rate && newItems[index].exchange_rate > 0) {
				price_unit_order = price_unit_order * newItems[index].exchange_rate;
			} else {
				price_unit_order = 0;
			}
		}

		if (
			Object.prototype.hasOwnProperty.call(newItems[index], "price_order") &&
			price_unit_order &&
			price_unit &&
			Number(price_unit_order) !== Number(price_unit / container_content)
		) {
			const priceOrder = String(price_unit_order * container_content * newItems[index].quantity).replace(".", ",");
			return {
				text: `El precio neto del producto ${newItems[index].product_name} en la OC es de $${formatMilesDecimalNew(
					priceOrder,
				)}${textCurrency} Sin embargo, en la factura actual se ingreso $${formatMilesDecimalNew(newItems[index].price_total)}${textCurrency}.`,
				completed: false,
				index_item: index,
			};
		}

		if (
			Object.prototype.hasOwnProperty.call(newItems[index], "price_order") &&
			price_unit_order &&
			price_unit &&
			Number(price_unit_order) === Number(price_unit / container_content)
		) {
			return null;
		}
		return null;
	};

	const handleValidPrice = (items = null, index = null, type_currency_id = null) => {
		let alert = null;
		let newItems = items ? [...items] : [...data.items];

		if (!type_currency_id) {
			type_currency_id = data.type_currency_id;
		}

		let textCurrency = Number(type_currency_id) === 1 || type_currency_id === "" ? "CLP" : "USD";

		let newAlerts = [...alerts];

		if (index !== null) {
			alert = handleValidPriceItem(newItems, index, textCurrency);

			if (alert) {
				newAlerts = newAlerts.filter((a) => a.index_item !== index);
				newAlerts.push(alert);
			} else {
				newAlerts = newAlerts.filter((a) => a.index_item !== index);
			}
		} else {
			newItems.forEach((item, index) => {
				alert = handleValidPriceItem(newItems, index, textCurrency);
				if (alert) {
					newAlerts = newAlerts.filter((a) => a.index_item !== index);
					newAlerts.push(alert);
				} else {
					newAlerts = newAlerts.filter((a) => a.index_item !== index);
				}
			});
		}

		setAlerts(newAlerts);
	};

	if (isFetchingExcel) {
		return <Fetching />;
	}

	return (
		<>
			<Head
				title={option === "ingresar" ? "Ingresar Factura" : `${_.capitalize(option)} Factura`}
				isFetching={isFetching && !isLoading}
				input_file={true}
				name_file={"Excel"}
				uploadFile={uploadFile}
				validFile={validFile}
				downloadFile={"https://d3inv09b4yglev.cloudfront.net/base/Plantilla Agroinventario.xlsx"}
			/>

			{isLoading || loadingSave ? (
				<Fetching />
			) : (
				<Row className={classes.row_global_card}>
					<CreateOrderSaleHead
						params={params}
						data={data}
						setData={setData}
						setIsFetchingDetail={setIsFetchingDetail}
						checkDetailOC={checkDetailOC}
						handleValidPrice={handleValidPrice}
					/>
					<CreateOrderSaleTableDetail
						params={params}
						data={data}
						setData={setData}
						isFetchingDetail={isFetchingDetail}
						alerts={alerts}
						setAlerts={setAlerts}
						handleValidPrice={handleValidPrice}
					/>
					<CreateOrderSaleDocument data={data} setData={setData} />
					<CreateOrderSaleButton params={params} base={base} data={data} setData={setData} save={save} isFetchingDetail={isFetchingDetail} />
				</Row>
			)}
		</>
	);
};

export default CreateOrderSale;
